import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setSessionToken } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Persist Bearer token (works behind ingress that rewrites credentialed cookies)
        if (res.data.session_token) setSessionToken(res.data.session_token);
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        navigate("/admin", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Authentication failed");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFAF0] text-emerald-950">
      <div className="text-center">
        <div className="font-[Cormorant_Garamond] text-2xl">{error ? "Authentication failed" : "Signing you in…"}</div>
        {error && <p className="text-rose-600 mt-2 font-[Outfit] text-sm">{error}</p>}
      </div>
    </div>
  );
}
